// Build-time registry of automation configs.

import type { AutomationConfig } from '@/lib/types';
import { APPurchaseInvoice } from './ap-purchase-invoice';

export const automations: AutomationConfig[] = [
  APPurchaseInvoice as unknown as AutomationConfig,
];

export function getAutomation(slug: string): AutomationConfig | undefined {
  return automations.find((a) => a.slug === slug);
}

export function automationsByDepartment(): Record<string, AutomationConfig[]> {
  return automations.reduce<Record<string, AutomationConfig[]>>((acc, a) => {
    (acc[a.department] = acc[a.department] || []).push(a);
    return acc;
  }, {});
}
